<div>
  <svg
    [attr.width]="width"
    [attr.height]="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    [style.opacity]="opacity"
  >
    <!-- Gradient ONLY if colors exist -->
    @if(hasGradient){
    <defs>
      <linearGradient
        [attr.id]="gradientId"
        gradientUnits="userSpaceOnUse"
        x1="0%"
        y1="0%"
        x2="100%"
        y2="100%"
      >
        <stop offset="0%" [attr.stop-color]="startColor" />
        <stop offset="100%" [attr.stop-color]="endColor" />
      </linearGradient>
    </defs>
    }

    <path
      d="M12 2L14.5 8.5L21 11L14.5 13.5L12 20L9.5 13.5L3 11L9.5 8.5L12 2Z"
      [attr.fill]="hasGradient ? 'url(#' + gradientId + ')' : defaultColor"
    />
    <path
      d="M19 16L19.8 18.2L22 19L19.8 19.8L19 22L18.2 19.8L16 19L18.2 18.2L19 16Z"
      [attr.fill]="hasGradient ? 'url(#' + gradientId + ')' : defaultColor"
      style="opacity: 0.7"
    />
    <path
      d="M6 4L6.6 5.6L8.2 6.2L6.6 6.8L6 8.4L5.4 6.8L3.8 6.2L5.4 5.6L6 4Z"
      [attr.fill]="hasGradient ? 'url(#' + gradientId + ')' : defaultColor"
      style="opacity: 0.6"
    />
  </svg>
</div>
